import { EMAIL_VERIFY_BANNER_DISMISSED_STORAGE_KEY } from 'src/utils/constants/common';
import { adobeCjaEventEmitter } from 'modules/adobe-cja/utils';
import { CJA_EVENTS, LINK_CATEGORIES, LINK_NAMES, LINK_TYPES } from 'modules/adobe-cja/constants';

import FouWarningBanner from './components/fou-warning-banner';
import FouEmailSendModal from './components/fou-email-send-modal';
import FouWarningBannerOnPage from './components/fou-warning-banner-on-page';

const PAYMENT_ROUTES = ['payment_new_data_manager', 'payment_edit_data_manager'];

export default {
  components: {
    FouWarningBanner,
    FouEmailSendModal,
    FouWarningBannerOnPage
  },
  props: {
    isBannerOnPage: {
      type: Boolean,
      default: false,
    },
    dismissable: {
      type: Boolean,
      default: true,
    },
    showCloseIcon: {
      type: Boolean,
      default: true,
    },
    labelKey: {
      type: String,
      default: '',
    },
    showVerifyButton: {
      type: Boolean,
      default: true,
    },
    onlyGracePeriodExpired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isEmailVerificationOpen: false,
      bannerDismissedKey: EMAIL_VERIFY_BANNER_DISMISSED_STORAGE_KEY,
      bannerDismissed:
        window.localStorage.getItem(EMAIL_VERIFY_BANNER_DISMISSED_STORAGE_KEY) === 'true',
    };
  },
  computed: {
    isEmailVerified() {
      return this.$store.getters['auth/isEmailVerified'];
    },

    gracePeriodExpired() {
      if (this.$store.getters['auth/hasRole'](['foundrySupport'])) return false;
      return this.$store.getters['auth/isGracePeriodExpired'];
    }
  },

  mounted() {
    const isSignUp = this.$store.getters['auth/isSignUp'];
    if (isSignUp && !this.isEmailVerified) {
      this.isEmailVerificationOpen = true;
      this.$store.commit('auth/clearIsSignUp');
    }
  },
  
  methods: {
    toggleEmailVerificationModal(isOpen) {
      this.isEmailVerificationOpen = !!isOpen;
    },
    
    openEmailVerificationModal() {
      const isPaymentContext = PAYMENT_ROUTES.includes(this.$route?.name);
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: isPaymentContext
            ? LINK_CATEGORIES.EMAIL_VERIFICATION_BANNER_PAYMENT_SETUP
            : LINK_CATEGORIES.EMAIL_VERIFICATION_BANNER,
          linkSection: window?.pageInfoGlobal?.pageInfo?.pageSection || '',
          linkName: isPaymentContext
            ? LINK_NAMES.VERIFY_WITH_EMAIL_PAYMENT_SETUP
            : LINK_NAMES.VERIFY,
          linkType: isPaymentContext ? LINK_TYPES.BUTTON : LINK_TYPES.ICON
        }
      });
      this.toggleEmailVerificationModal(true);
    },
    
    closeEmailVerificationModal() {
      this.toggleEmailVerificationModal(false);
    },

    dismissEmailVerifyBanner() {
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.EMAIL_VERIFICATION_BANNER,
          linkSection: window?.pageInfoGlobal?.pageInfo?.pageSection || '',
          linkName: LINK_NAMES.VERIFY_WITH_EMAIL_DISMISSED_BANNER,
          linkType: LINK_TYPES.ICON
        }
      });
      this.bannerDismissed = true;
      window.localStorage.setItem(this.bannerDismissedKey, 'true');
    },
  },
};
